import React, { useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import payloftLogo from "../assets/images/payloft-logo.png";
import Migrate from "../assets/images/migrate.png";
import ProfilePhoto from "../assets/images/profile-photo.png";
import { useAuth } from "../context/AuthContextProvider";
import MigrateModal from "./MigrateModal";

const PaymentNav = () => {
  const location = useLocation();
  const { logout, user, setIsModalOpen, isModalOpen, globalProfile } =
    useAuth();
  const [isOpen, setIsOpen] = useState(false);

  const inactiveClass = "flex items-center py-2 px-5 gap-3 text-gray-400";
  const activeClass = "flex items-center py-2 px-5 gap-3 text-primary relative";

  const links = [
    // {
    //   to: "/payments",
    //   text: "Transfer",
    // },
    // {
    //   to: "/payments/card",
    //   text: "Card",
    // },

    {
      to: "/payments/payment-links",
      text: "Payment Links",
    },
    {
      to: "/payments/digital-invoice",
      text: "Digital Invoice",
    },

    {
      to: "/payments/split-payment",
      text: "Split Payment",
    },
    // {
    //   to: "/payments/ussd",
    //   text: "USSD",
    // },
  ];

  return (
    <div className="bg-arena-background h-full font-LT">
      <div className="flex">
        <div
          className={`bg-white h-screen lg:w-[20%] md:w-[22%] xl:w-[13%] w-[267px] pt-4 z-50 flex flex-col justify-between ${isOpen ? "translate-x-0" : "-translate-x-full"
            } md:translate-x-0 fixed md:relative left-0 top-0 bottom-0 overflow-y-auto md:overflow-y-visible`}
        >
          <div className="flex flex-col items-center">
            <img
              src={window.__TENANT__?.logo ?? payloftLogo}
              alt="logo"
              className="w-[92px] h-auto"
            />
            <div className="w-[191.98px] ">
              <NavLink className="flex items-center gap-3" to="/dashboard">
                <span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.4">
                      <path
                        d="M2.35 12.35L5.14 15.14C5.46 15.46 6 15.24 6 14.79L6 13L20 13C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11L6 11L6 9.20997C6 8.75997 5.46 8.53997 5.15 8.85997L2.36 11.65C2.16 11.84 2.16 12.16 2.35 12.35Z"
                        fill="#030229"
                      />
                    </g>
                  </svg>
                </span>
                <p className="text-gray-400 text-[12px] font-semibold">
                  Main Menu
                </p>
              </NavLink>
              <p className="text-text-orange text-base font-semibold mt-4 md:px-3 lg:px-0">
                Payments
              </p>

              <div className="">
                {links.map((link, index) => (
                  <NavLink
                    key={index}
                    to={link.to}
                    className={
                      location.pathname.includes(link.to)
                        ? activeClass
                        : inactiveClass
                    }
                  >
                    <p className="text-base font-semibold">{link.text}</p>
                    {location.pathname.includes(link.to) ? (
                      <div className="absolute top-1/2 left-[65%] transform -translate-y-1/2 w-12 h-px bg-primary"></div>
                    ) : null}
                  </NavLink>
                ))}
              </div>

              {/* <div className="border-t pt-6">
                <NavLink className="flex py-3 px-5 gap-3">
                  <img src={Migrate} alt="migrate" className="w-6 h-6" />
                  <p className="text-gray-400 text-base font-bold">
                    Migrate to Production
                  </p>
                </NavLink>
              </div> */}

              {user.migrated === true ||
                globalProfile === "PRODUCTION" ? null : (
                <div className="border-t pt-6">
                  <NavLink
                    className="flex py-3 px-5 gap-3"
                    onClick={() => setIsModalOpen(true)}
                  >
                    <img src={Migrate} alt="migrate" className="w-6 h-6" />
                    <p className="text-gray-400 text-base font-bold">
                      Migrate to Production
                    </p>
                  </NavLink>
                </div>
              )}
            </div>
          </div>
          {/* <div className="flex items-center gap-2 py-2 px-5">
            <img
              src={ProfilePhoto}
              alt="profile-pic"
              className="w-[45px] h-[43px]"
            />
            <div>
              <p className="font-bold text-[12px] ">Omoke Chuku</p>
              <p className="text-gray-400 text-[10px] font-semibold">
                T23456 - Admin
              </p>
            </div>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.24596 8.35841C6.88138 8.35841 6.5931 8.64175 6.5931 9.00008C6.5931 9.35008 6.88138 9.64175 7.24596 9.64175H12.3332V13.6251C12.3332 15.6667 10.6459 17.3334 8.56016 17.3334H4.43104C2.35376 17.3334 0.666504 15.6751 0.666504 13.6334V4.37508C0.666504 2.32508 2.36224 0.666748 4.43952 0.666748H8.57712C10.6459 0.666748 12.3332 2.32508 12.3332 4.36675V8.35841H7.24596ZM15.3584 6.11692L17.7917 8.54192C17.9167 8.66692 17.9834 8.82525 17.9834 9.00025C17.9834 9.16692 17.9167 9.33359 17.7917 9.45025L15.3584 11.8753C15.2334 12.0003 15.0667 12.0669 14.9084 12.0669C14.7417 12.0669 14.575 12.0003 14.45 11.8753C14.2 11.6253 14.2 11.2169 14.45 10.9669L15.7834 9.64192H12.3334V8.35859H15.7834L14.45 7.03359C14.2 6.78359 14.2 6.37525 14.45 6.12525C14.7 5.86692 15.1084 5.86692 15.3584 6.11692Z"
                fill="#F58220"
              />
            </svg>
          </div> */}
        </div>
        {isOpen && (
          <div
            className="bg-black opacity-50 absolute min-h-[100rem] w-full inset-0 z-40"
            onClick={() => setIsOpen(false)}
          ></div>
        )}
        {/* Hamburger menu */}
        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-gray-700 text-2xl rounded-md"
          >
            {!isOpen ? "☰" : "✕"}
          </button>
        </div>

        <div className="lg:w-[80%] md:w-[78%] xl:w-[87%] w-full md:px-6 lg:p-5">
          <Outlet />
        </div>
      </div>
      {isModalOpen && <MigrateModal />}
    </div>
  );
};

export default PaymentNav;
